module.exports = __webpack_public_path__ + "static/img/Jared_Polec_desktop.fcd1813.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Jared_Polec_desktop.jpg
// module id = CEpW
// module chunks = 0